import { render, staticRenderFns } from "./Cash.vue?vue&type=template&id=481b368b"
import script from "./Cash.vue?vue&type=script&lang=js"
export * from "./Cash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports